import { useLocation } from 'react-router-dom'
import { parse } from '../../utils/querystring'

const useQuery = () => parse(useLocation().search)

export default useQuery
